import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import {concat, isEmpty} from "lodash";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import Header from "../components/ContainerHeader";
import Form from "../components/projectNew/ProjectNewForm";

import { getOrganizationsWithoutRelationRole } from "../actions/resourceActions";
import { getUser } from "../actions/userActions";
import {DebugElement} from "../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";
import fetch from "../utils/fetch";
import {alertBackendError} from "../utils";
import {getApiPrefix_lagoon} from "../constants";

function log()
{
    console.log.apply( null, concat( [ '%cProjectNew qqq', 'color:green' ], arguments ));
}

const getJSONOrNull = async ({ url }) => {
    try {
        const response = await fetch( url );

        if (response.status === 200) {
            const content = await response.json();
            return content;
        }
        else
        {
            let errorText = await response.text();
            console.log({ errorText });
            alertBackendError({response});
            // alertBackendError ...
            return null;
        }
    } catch ( exception ) {
        console.log(exception);
        // alertBackendError ...
        alertBackendError({exception});
        return null;
        // return false;
    }
};

let sponsorAsResource = null;

const ProjectNew = ( props ) => {

    let { history, organizations } = props;

    const sponsor = sponsorAsResource && !isEmpty(sponsorAsResource.item)
        ? sponsorAsResource.item[0]
        : undefined;

    log( {sponsor, sponsorAsResource, organizations} );

  return (
    <div className="flex-col">
        <DebugElement text={"src/containers/ProjectNew.js"}/>

        <TouchPageHeader title="Žádost o nový projekt" />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      <Card>
        <CardText>
          <Form
            initialValues={{
              sponsor: sponsor,
              text: ""
            }}
            sponsorAsResource={sponsorAsResource}
            organization={organizations}
            history={history}
          />
        </CardText>
      </Card>
    </div>
  );
};

export default compose(
  connect(
      ( state ) =>
      {
        const { resource: { organizations } } = state;
        return { organizations };
      },
      {
          getUser,
          getOrganizationsWithoutRelationRole,
      }
  ),
  lifecycle({
    async componentWillMount() {
      const { getUser, getOrganizationsWithoutRelationRole } = this.props;

      sponsorAsResource = await getJSONOrNull({ url: `${getApiPrefix_lagoon()}/auth/requestResource?type=ORGANIZATION,PERSON&showAllForAdmin=true&includeMyself=true` });

      // There must be something which forces refresh of Form with dispatch()

      await getUser();
      await getOrganizationsWithoutRelationRole({ showAllForAdmin: true, includeMyself: true });
      log( {sponsorAsResource});
    }
  })
)(ProjectNew);



// WEBPACK FOOTER //
// ./src/pages/ProjectNew.js